export class HRCompetency {
  id:                   string;
  hrConfigId:           string;
  ownerEmployeeId:      string;
  title:                string;
  description:          string;
  active = true;
}
